// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class FilterFormReset extends WebComponent {
    didMount() {
        const form =  document.querySelector('#filterForm');
        window.addEventListener("pageshow", () => {
            form.reset();
        });
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FilterFormReset.js